(function($) {
  "use strict";

  jQuery(document).ready(function(){



//    $(".currency").on("click", function() {
//           $('.dropdown_currency').toggleClass('active_on');	  
//     });
    
  $('.product_navactive.vertical_mode').slick({
     vertical: true,
     slidesToShow: 3,
     nextArrow: '<button class="next"><i class="fa fa-angle-down"></i></button>',
     prevArrow: '<button class="prev"><i class="fa fa-angle-up"></i></button>',
     slidesToScroll: 1,
     verticalSwiping: true,
     
     autoplay: false
   });


   /*  product activation */
    $('.horizontal_carousel').owlCarousel({
        autoplay: true,
		loop: true,
        nav: true,
        autoplay: false,
        autoplayTimeout: 8000,
         margin:10,
        
        items: 3,
        navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
        responsiveClass:true,
		responsive:{
			0:{
				items:1,
			 },
			480:{
				items:2,
			},	
			992:{
				items:3,
			}

		  }
    });
    
    


    
    
  });
  
})(jQuery);
